import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFLookupVendor } from "../../../Shared/NewForms/NFLookupVendor";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";
import { NFLookupVendorCustomer } from "../../../Shared/NewForms/NFLookupVendorCustomer";

const VendorItemDetailMain = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={t("CreatedDate")} />
        </Col>
        <Col sm={6}>
          <NFLookupVendor fieldName={"vendorId"} title={t("Vendor")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupVendor fieldName={"vendorId"} title={t("Vendor")} />
        </Col>
        <Col sm={6}>
          <NFLookupVendor fieldName={"productId"} title={t("Product")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName={"vendorId"} title={t("Vendor")} />
        </Col>
        <Col sm={6}>
          <NFLookupVendor fieldName={"productId"} title={t("Product")} />
        </Col>
      </Row>
    </>
  );
};

export default VendorItemDetailMain;
